var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-body"},[_c('div',{staticClass:"login-bg"}),_c('h1',{staticClass:"company-ci"},[_c('img',{staticStyle:{"max-width":"400px"},attrs:{"src":require(`@/assets/images/img_top/logo_gnb.png`),"alt":"RedWood Health"}})]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }